module.exports = __webpack_public_path__ + "img/app-store.34aeb942.svg";